<div class="backgroundImage">
    <app-header login='yes'></app-header>
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            </div>
            <ng-template #mymodal let-modal>
                <div class="modal-header main-backgroundcolor">
                    <h4 class="modal-title color" id="modal-basic-title">{{Title | titlecase}}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true" class="color">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="loading == false">
                        <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
                    </div>
                    <div *ngIf="loading">
                        <div class="card margin-b" *ngFor="let props of loadMoreArr; let i = index">
                            <div class="card-body border-r">
                                <div class="display">
                                    <div class="image-wrapper">
                                        <img [src]="props.photo" (error)="getErrorImage($event)">
                                    </div>
                                    <div class="text-area display justify-content1">
                                        <div>
                                            <h5 class="card-title">{{props.name}}</h5>
                                            <p>{{(props.description | slice:0:35)}}</p>
                                        </div>
                                        <div class="form-check-input-inner">
                                            <!-- Use radio for static campus type selection; checkbox for others -->
                                            <ng-container *ngIf="props.type === 'static'; else nonStatic">
                                                <input
                                                    type="radio"
                                                    name="campusType"
                                                    [checked]="communityName === props.name"
                                                    (change)="selectItem($event, props)"
                                                    class="form-check-input">
                                            </ng-container>
                                            <ng-template #nonStatic>
                                                <input
                                                    type="checkbox"
                                                    [value]="props._id"
                                                    [checked]="isCommunitySelected(props._id)"
                                                    (change)="selectItem($event, props)"
                                                    class="form-check-input">
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <h6 *ngIf="showError" class="error">{{modalError}}</h6>
                    </div>
                </div>
                <div class="modal-footer">
                    <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="modal.close('Save click')">
                        Select</button>

                    <button *ngIf="staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="close(ministrymodal)">
                        Select</button>
                </div>
            </ng-template>
            <ng-template #mymodal1 let-modal>
                <div class="modal-header main-backgroundcolor">
                    <h4 class="modal-title color" id="modal-basic-title">{{Title | titlecase}}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true" class="color">&times;</span>
                    </button>
                </div>
                <div class="modal-body faith_modal">
                    <div *ngIf="loading == false">
                        <!-- <app-card-skelton *ngFor="let faith of faithList"></app-card-skelton> -->
                    </div>
                    <div *ngIf="loading">
                        <form [formGroup]="form">
                            <div class="card faith_card">
                                <!-- 1st Level Faith -->
                                <div class="form-group mb-3">
                                    <ng-select [items]="faithList" formControlName="faith" bindLabel="name"
                                        bindValue="_id" placeholder="Select Faith" [(ngModel)]="selectedFaith"
                                        (change)="changeFaith($event)">
                                        <ng-template ng-header-tmp>
                                            <small class="form-text text-muted">Loaded {{ skip1 }} of {{
                                                faithTotalRecord
                                                }}</small>
                                        </ng-template>
                                        <div>
                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                {{ item.name }}
                                            </ng-template>
                                        </div>
                                    </ng-select>
                                </div>

                                <!-- ** second level faith -->
                                <div class="form-group mb-3">
                                    <ng-select formControlName="subFaith" [items]="faithBranches"
                                        [(ngModel)]="selectedFaith2" [virtualScroll]="true" bindLabel="name"
                                        bindValue="_id" [placeholder]="'Faith level 2'"
                                        (change)="changeSubFaith($event)">
                                        <div>
                                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                                {{ item.name }}
                                            </ng-template>
                                        </div>
                                    </ng-select>
                                </div>

                                <!-- ** 3rd level faith -->
                                <div class="form-group">
                                    <ng-select formControlName="subFaithSub" [items]="faithDenominations"
                                        [virtualScroll]="true" bindLabel="name" bindValue="_id"
                                        (change)="changeSubFaith2($event)" [(ngModel)]="selectedFaith3"
                                        [placeholder]="'Faith level 3'">
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            {{ item.name }}
                                        </ng-template>
                                    </ng-select>
                                </div>

                            </div>
                        </form>
                        <h6 *ngIf="showError" class="error">{{modalError}}</h6>
                        <!-- <div *ngIf="showButton" style="text-align:center">
                            <button type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                                (click)="showMore()">
                                Show more</button>
                        </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="modal.close('Save click')">
                        Select</button>
                    <button *ngIf="staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="close(ministrymodal)">
                        Select</button>
                </div>
            </ng-template>
            <ng-template #ministrymodal let-modal>
                <div class="modal-header main-backgroundcolor">
                    <h4 class="modal-title color" id="modal-basic-title">{{Title | titlecase}}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true" class="color">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="loading == false">
                        <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
                    </div>
                    <div *ngIf="loading">
                        <div class="margin-b">
                            <input class="form-control" (keyup)="search($event)" type="text"
                                placeholder="Search Ministry" />
                        </div>
                        <div class="card margin-b" *ngFor="let props of loadMoreArr; let i = index">
                            <div class="card-body border-r">
                                <div class="display">
                                    <div class="image-wrapper">
                                        <img [src]="props.photo" (error)="getErrorImage($event)">
                                    </div>
                                    <div class="text-area display justify-content1">
                                        <div>
                                            <h5 class="card-title">{{props.name}}</h5>
                                            <p>{{(props.description | slice:0:35)}}</p>
                                        </div>
                                        <div class="form-check-input-inner">
                                            <input type="checkbox" [value]="props._id" [checked]="isCommunitySelected(props._id)"
                                              (change)="selectItem($event,props)" class="form-check-input"
                                              id="exampleCheck1">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div style="text-align:center">
                            <button type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                                (click)="showMore()">
                                Show more</button>
                        </div>
                        <h6 *ngIf="showError" class="error">{{modalError}}</h6>
                    </div>
                </div>
                <div class="modal-footer">
                    <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="modal.close('Save click')">
                        Select</button>

                    <button *ngIf="staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
                        (click)="close(ministrymodal)">
                        Select</button>
                </div>
            </ng-template>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="sin-in-page-top">
                    <div class="card-wrapper">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div style="min-height: 500px;">
                                <div>
                                    <div class="header main-backgroundcolor text-center margin-b color">
                                        Basic Information
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label class="btn-bs-file btn btn-lg btn-dark">
                                                    Upload Image
                                                    <input type="file" (change)="uploadProfile($event)" />
                                                </label>
                                                <input type="hidden" formControlName="photo"
                                                    [ngClass]="{ 'is-invalid': submitted && f.photo.errors }">
                                                <div *ngIf="submitted && f.photo.errors" class="invalid-feedback">
                                                    <div *ngIf="f.photo.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>
                                            <div class="profile-image" *ngIf="profilePic">
                                                <div class="image-wrapper"
                                                    style=" width: 143px; height: 143px;border-radius: 50%;">
                                                    <img [src]="renderImage(profilePic)" alt="Profile-Pic" width=""
                                                        height="">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label class="btn-bs-file btn btn-lg btn-dark">
                                                    Upload Cover Image
                                                    <input type="file" (change)="uploadBanner($event)" />
                                                </label>
                                                <input type="hidden" formControlName="coverPhoto"
                                                    [ngClass]="{'is-invalid': submitted && f.coverPhoto.errors }">
                                                <div *ngIf="submitted && f.coverPhoto.errors" class="invalid-feedback">
                                                    <div *ngIf="f.coverPhoto.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>

                                            <div class="upload-image" *ngIf="coverPhoto">
                                                <div class="image-wrapper"
                                                    style="width: 143px; height: 143px;border-radius: 50%;">
                                                    <img [src]="renderImage(coverPhoto)" alt="Cover-Pic" width=""
                                                        height="">
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_name">Name of Ministry <span class="asterisk">*</span>
                                                </label>
                                                <input type="text" formControlName="name" class="form-control"
                                                    placeholder="Name of Ministry"
                                                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                                    <div *ngIf="f.name.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-md-6">
                                            <div class="form-group register-input"
                                                [class.has-error]="f.communityUserName.errors && (f.submitted || f.communityUserName.touched)">
                                                <label for="form_lastname">User Name (no spaces) <span
                                                        class="asterisk">*</span></label>
                                                <input type="text" formControlName="communityUserName"
                                                    class="form-control" placeholder="User Name">
                                                <div
                                                    *ngIf="f.communityUserName.errors && (f.submitted || f.communityUserName.touched)">
                                                    <div class="text-white text-left"
                                                        *ngIf="f.communityUserName.errors.required">Username is
                                                        required.</div>
                                                    <div class="text-white text-left"
                                                        *ngIf="f.communityUserName.errors.whitespaceOrSpecialCharacter">
                                                        Username cannot contain whitespace or special characters.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_lastname">User Email <span class="asterisk">*</span>
                                                </label>
                                                <input type="email" formControlName="email" class="form-control"
                                                    placeholder="User Email"
                                                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                                    <div *ngIf="f.email.errors.required">{{errorMessage}}</div>
                                                    <div *ngIf="f.email.errors.email">{{emailMessage}}</div>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- </div>
                                    <div class="row"> -->
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Slogan / Tag Phrase <span
                                                        class="asterisk">*</span> </label>
                                                <textarea maxlength="100" class="form-control" formControlName="logLine"
                                                    placeholder="Slogan" rows="1"
                                                    [ngClass]="{ 'is-invalid': submitted && f.logLine.errors }">
                                                    </textarea>
                                                <div style="text-align: right;">
                                                    <p style="margin-bottom: -1rem;" class="small color">
                                                        {{f.logLine.value?.length || 0}}/100</p>
                                                </div>
                                                <div *ngIf="submitted && f.logLine.errors" class="invalid-feedback">
                                                    <div *ngIf="f.logLine.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Faith <span class="asterisk">*</span>
                                                </label>
                                                <ng-select
                                                    [items]="faithList"
                                                    formControlName="faith"
                                                    bindLabel="name"
                                                    bindValue="_id"
                                                    placeholder="Select Faith"
                                                    [(ngModel)]="selectedFaith"
                                                    (change)="changeFaith($event)"
                                                    [ngClass]="{ 'is-invalid': submitted && f.faith.errors }">
                                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                                        {{ item.name }}
                                                    </ng-template>
                                                </ng-select>
                                                <div *ngIf="submitted && f.faith.errors" class="invalid-feedback">
                                                    <div *ngIf="f.faith.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>

                                            <div class="form-group" *ngIf="faithBranches?.length">
                                                <label>Branch</label>
                                                <ng-select
                                                    formControlName="subFaith"
                                                    [items]="faithBranches"
                                                    [(ngModel)]="selectedFaith2"
                                                    [virtualScroll]="true"
                                                    bindLabel="name"
                                                    bindValue="_id"
                                                    placeholder="Branch"
                                                    (change)="changeSubFaith($event)">
                                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                                        {{ item.name }}
                                                    </ng-template>
                                                </ng-select>
                                            </div>

                                            <div class="form-group" *ngIf="faithDenominations?.length">
                                                <label>Denomination</label>
                                                <ng-select
                                                    formControlName="subFaithSub"
                                                    [items]="faithDenominations"
                                                    [(ngModel)]="selectedFaith3"
                                                    [virtualScroll]="true"
                                                    bindLabel="name"
                                                    bindValue="_id"
                                                    placeholder="Denomination"
                                                    (change)="changeSubFaith2($event)">
                                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                                        {{ item.name }}
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <!-- </div>

                                    <div class="row"> -->
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Member of Association <span
                                                        class="asterisk">*</span></label>
                                                <input type="text" class="form-control" [value]="communityName"
                                                    placeholder="Member of Association"
                                                    (click)="open(mymodal,'What type of campus are you registering?')"
                                                    [ngClass]="{ 'is-invalid': submitted && f.associatedBy.errors }">
                                                <div *ngIf="submitted && f.associatedBy.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.associatedBy.errors.required">{{errorMessage}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group register-input">
                                              <label for="form_name">Average Weekly Attendance</label>
                                        <select class="form-control" formControlName="avgWeeklyAttendence">
                                            <option value="">Select</option>
                                            <option value="More than 2000 people">More than 2000 people</option>
                                            <option value="Between 301 – 2000 people">Between 301 – 2000 people</option>
                                            <option value="Between 51 – 300 people">Between 51 – 300 people</option>
                                            <option value="50 or fewer people">50 or fewer people</option>
                                            <option value="Not applicable">Not applicable</option>
                                        </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Tax or Organisation ID </label>
                                                <input formControlName="certificateNo" type="text" class="form-control"
                                                    placeholder="Tax or Organisation ID"
                                                    [ngClass]="{ 'is-invalid': submitted && f.certificateNo.errors }">
                                                <div *ngIf="submitted && f.certificateNo.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.certificateNo.errors.required">{{errorMessage}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- </div>
                                    <div class="row"> -->
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Country of Registration <span
                                                        class="asterisk">*</span></label>

                                                <select class="form-control" formControlName="countryOFReg"
                                                    [ngClass]="{ 'is-invalid': submitted && f.countryOFReg.errors }">
                                                    <option value=""> Select</option>
                                                    <option *ngFor="let props of countryList " [value]=props.name>
                                                        {{props.name}}</option>

                                                </select>

                                                <div *ngIf="submitted && f.countryOFReg.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.countryOFReg.errors.required">{{errorMessage}}
                                                    </div>
                                                </div>


                                                <!-- <input type="text" formControlName="countryOFReg" class="form-control"
                                                    placeholder="Country of Registration"
                                                    [ngClass]="{ 'is-invalid': submitted && f.countryOFReg.errors }">
                                                <div *ngIf="submitted && f.countryOFReg.errors"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.countryOFReg.errors.required">{{errorMessage}}
                                                    </div>
                                                </div> -->


                                            </div>
                                        </div>
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Select Ministry Type <span
                                                        class="asterisk">*</span></label>
                                                <ng-select
                                                    [items]="allCommunityListing"
                                                    bindLabel="name"
                                                    bindValue="_id"
                                                    [multiple]="true"
                                                    placeholder="Select Ministry Types"
                                                    formControlName="profitType"
                                                    [closeOnSelect]="false"
                                                    [searchable]="true"
                                                    [clearable]="true"
                                                    [ngClass]="{ 'is-invalid': submitted && f.profitType.errors }">
                                                </ng-select>

                                                <div *ngIf="submitted && f.profitType.errors" class="invalid-feedback">
                                                    <div *ngIf="f.profitType.errors.required">{{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>


                                        <!-- </div>

                                    <div class="row"> -->
                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">GuideStar Profile Link (US
                                                    non-profits)</label>
                                                <input type="text" class="form-control" formControlName="guideStarID"
                                                    placeholder="GuideStar Profile Link (US non-profits)" />

                                            </div>
                                        </div>

                                        <div class="col-md-6 ">
                                            <div class="form-group register-input">
                                                <label for="form_name">Business registry or non-profit directory link
                                                </label>
                                                <input type="text" class="form-control" formControlName="bridgeNumber"
                                                    placeholder="Business registry or non-profit directory link" />

                                            </div>
                                        </div>
                                    <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_name">Main Contact Number <span
                                                        class="asterisk">*</span></label>
                                                <input type="text" class="form-control" ng2TelInput
                                                    [ng2TelInputOptions]="{initialCountry: 'us'}"
                                                    (ng2TelOutput)="getNumber($event,'contactNo')"
                                                    formControlName="contactNo"
                                                    (countryChange)="onCountryChange($event)"
                                                    (hasError)="hasError($event,'contactNo')"
                                                    [ngClass]="{ 'is-invalid':!phoneError}" />
                                            </div>
                                            <div *ngIf="!phoneError" class="error">
                                                Invalid
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_name">Public Email</label>
                                                <input type="email" class="form-control"
                                                    formControlName="publicEmail"
                                                    placeholder="Public Email"
                                                    [ngClass]="{ 'is-invalid': submitted && f.publicEmail.errors }">
                                                <div *ngIf="submitted && f.publicEmail.errors" class="invalid-feedback">
                                                    <div *ngIf="f.publicEmail.errors.email">Please enter a valid email.</div>
                                                </div>
                                            </div>
</div>
                                        <!-- </div>
                                    <div class="row"> -->
                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_name">Emergency Number</label>
                                                <input type="text" class="form-control" ng2TelInput
                                                    [ng2TelInputOptions]="{initialCountry: 'us'}"
                                                    (ng2TelOutput)="getNumber($event,'HotLinkContactNo')"
                                                    (intlTelInputObject)="telInputObject($event)"
                                                    formControlName="HotLinkContactNo"
                                                    (hasError)="hasError($event,'HotLinkContactNo')"
                                                    [ngClass]="{ 'is-invalid':!thirdPhone }" />
                                                <!--
                                                <ngx-intl-tel-input [cssClass]="'form-control'"
                                                    [preferredCountries]="preferredCountries"
                                                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                                    [searchCountryFlag]="true"
                                                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                                    [selectFirstCountry]="false"
                                                    [selectedCountryISO]="CountryISO.UnitedStates" [maxLength]="15"
                                                    [phoneValidation]="false" [separateDialCode]="separateDialCode"
                                                    [numberFormat]="PhoneNumberFormat.National" name="phone"
                                                    formControlName="hotLinkContactNo">

                                                </ngx-intl-tel-input> -->

                                            </div>
                                            <div *ngIf="!thirdPhone" class="error">
                                                Invalid
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group register-input">
                                                <label for="form_name">Ministry Website</label>
                                                <input type="text" class="form-control" formControlName="website"
                                                    placeholder="Ministry Website" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">IOS App Link</label>
                                                <input type="text" class="form-control" formControlName="iosAppLink"
                                                    placeholder="IOS App Link" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group register-input">
                                                <label for="form_name">Android App Link</label>
                                                <input type="text" class="form-control" formControlName="androidAppLink"
                                                    placeholder="Android App Link" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="submitted && form.invalid" class="error">
                                Please complete all required fields.
                            </div>
                            <br>
                            <button type="submit" class="btn btn-lg btn-block btn-primary color">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
